export default "__VITE_ASSET__DjIXg303__"